var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Content',{staticClass:"modal fade",attrs:{"id":_vm.modal_id}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }